import React from 'react';
import BusinessList from '../components/BusinessManagement/BusinessList';
import BusinessRequest from '../components/BusinessManagement/BusinessRequest';
import { Route, Routes } from 'react-router-dom';
import BusinessProfile from '../components/BusinessManagement/BusinessProfile';
import NotFound from '../components/NotFound';
import BusinessReports from '../components/BusinessManagement/BusinessReport';

const Business = () => {
  return (
    <Routes>
      <Route path="/" element={<BusinessRequest />} />
      <Route path="list/:id" element={<BusinessProfile />} />
      <Route path="/list" element={<BusinessList />} />
      <Route path="/report" element={<BusinessReports />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Business;
